import React from 'react';
import TownCentreIcon from '../atoms/icons/towncentre';
import SkiBusIcon from '../atoms/icons/skibus';
import SkiliftIcon from '../atoms/icons/skilift';
import PisteIcon from '../atoms/icons/piste';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useTranslation } from 'react-i18next';
import Mountain from '../atoms/icons/mountain';
import CalendarIcon from '../atoms/icons/calendar';
import HikingLevel from '../atoms/icons/hiker';
import { bgColors } from '../../assets/colors';
import useHideOnSite from '../../hooks/useLanguageFilter';

const Label = ({ blok, alignColumns, index, containerSize }) => {
  const { t } = useTranslation('labels');

  if (useHideOnSite(blok.hide_on_site)) return null;

  const types = {
    'city-center': <TownCentreIcon />,
    'ski-bus': <SkiBusIcon />,
    'ski-lift': <SkiliftIcon />,
    'black-runs': <PisteIcon />,
    'red-runs': <PisteIcon fill="#FF0000" />,
    'blue-runs': <PisteIcon fill="#0000FF" />,
    peak: <Mountain />,
    monday: <CalendarIcon />,
    tuesday: <CalendarIcon />,
    wednesday: <CalendarIcon />,
    thursday: <CalendarIcon />,
    friday: <CalendarIcon />,
    saturday: <CalendarIcon />,
    sunday: <CalendarIcon />,
    'hiking-level-1': <HikingLevel level={1} />,
    'hiking-level-2': <HikingLevel level={2} />,
    'hiking-level-3': <HikingLevel level={3} />,
    'hiking-level-4': <HikingLevel level={4} />,
  };

  const showValueInIcon = ['black-runs', 'red-runs', 'blue-runs'].includes(
    blok.type,
  );

  const backgroundColors = bgColors;

  const backgroundColor = backgroundColors[blok.color] || 'bg-yellow-15';

  if (blok.type === 'image') {
    return (
      <div className="" style={{ border: 0 }}>
        <img
          className={`max-h-16 ${
            containerSize === 'w-full'
              ? 'md:max-h-24 lg:max-h-32 max-w-[250px]'
              : ''
          } `}
          src={`${blok.image?.filename}/m/512x0`}
          alt={blok.image?.alt}
        />
      </div>
    );
  } else
    return (
      <div
        className={`z-20 ${
          index > 0 ? 'hidden md:flex' : 'flex'
        } ${index} items-center rounded flex-nowrap ${
          alignColumns
            ? 'justify-start w-full m-0 md:mx-4'
            : 'items-center w-max ml-2 my-0 md:ml-4'
        } ${backgroundColor}  p-2 md:px-4 `}
        key={blok._uid}
        {...storyblokEditable(blok)}
      >
        {blok.type && (
          <span className="mr-2 relative text-xxs lg:text-xs">
            {types[blok.type]}
            {showValueInIcon && (
              <span className="absolute top-0 text-white mr-4">
                {blok.value}
              </span>
            )}
          </span>
        )}

        <span>
          {blok.show_description && blok.type && t(blok.type)}{' '}
          {!showValueInIcon && (
            <span className="font-bold text-xs lg:text-sm">{blok.value}</span>
          )}
        </span>
      </div>
    );
};

export default Label;
